function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import DatePicker from './DatePicker';
const DateTimePicker = _ref => {
  let {
    selected,
    onChange,
    className,
    ...rest
  } = _ref;
  const transformDate = date => {
    const newDate = new Date();
    newDate.setHours(0, 0, 0, 0);
    return date ? new Date(date) : undefined;
  };
  return /*#__PURE__*/React.createElement(DatePicker, _extends({}, rest, {
    className: className,
    selected: transformDate(selected),
    showTime: true,
    showTimeSelect: true,
    onChange: onChange,
    shouldFormatDate: false
  }));
};
export default DateTimePicker;